import { createBrowserHistory,createMemoryHistory ,createHashHistory} from 'history';

export const history = createBrowserHistory();
//export const history = createMemoryHistory();
//export const history = createHashHistory();